import { Module } from 'wrapper6';

export default class NewsEventsFilter extends Module {
  ready() {
    const WIDGET_CONTAINER = document.querySelector('.so-widget-mtt-news-events');

    if (WIDGET_CONTAINER) {
      this.LIST_ITEMS = document.querySelectorAll('.news-events-list');
      this.init();
    }
  }

  init() {
    for (let i = 0; i < this.LIST_ITEMS.length; i++) {
      const LI = this.LIST_ITEMS[i];
      LI.addEventListener('click', e => this.changeContent(e), false);
    }
  }

  changeContent(e) {
    const TARGET = e.currentTarget;

    if (TARGET.classList.contains('active')) {
      return false;
    }

    this.hideActiveItems();
    this.showClickedItems(TARGET);
  }

  hideActiveItems() {
    const ACTIVE_LIST = document.querySelector('.news-events-list.active');
    const ACTIVE_CONTENT = document.querySelector('.so-widget-mtt-news-events .cards.active');

    ACTIVE_LIST.classList.remove('active');
    ACTIVE_CONTENT.classList.remove('active');
  }

  showClickedItems(clickedElem) {
    const POST_TYPE = clickedElem.getAttribute('data-type');
    const TARGET_CONTENT = document.querySelector('.so-widget-mtt-news-events .cards[data-type="' + POST_TYPE + '"]');

    clickedElem.classList.add('active');
    TARGET_CONTENT.classList.add('active');
  }
}